import React from "react";

import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { makeStyles } from "tss-react/mui";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import { KMKDialog } from "../../Common";

const useStyles = makeStyles()((theme) => ({
  dialogPaper: {
    "& .MuiPaper-root.MuiDialog-paper": {
      maxWidth: "720px",
      width: "720px",
    },
  },
  container: {
    padding: "24px 24px 24px 24px",
    backgroundColor: "#FFFFFF",
    minHeight: "50px",
    textAlign: "left",
  },
  Toolbar: {
    width: "100%",
    fontSize: "1.1rem",
    backgroundColor: "white",
    color: "black",
  },
}));

export default function ErrorLog({ open, handleCancel, popupTitle, jobErrorList }) {
  const { classes } = useStyles();

  return (
    <KMKDialog className={classes.dialogPaper} open={open} onClose={handleCancel}>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar className={classes.Toolbar}>{popupTitle}</Toolbar>
        <IconButton
          aria-label="close"
          onClick={handleCancel}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "black",
          }}
        >
          <CloseIcon />
        </IconButton>
      </AppBar>
      <Box sx={{ width: "100%" }} className={classes.container}>
        {jobErrorList.length ? (
          <Box textAlign={"left"} sx={{ wordBreak: "break-all" }}>
            <pre style={{ whiteSpace: "pre-wrap", fontFamily: "inherit" }}>{jobErrorList[0]}</pre>
          </Box>
        ) : (
          <Box textAlign={"center"}>No error found</Box>
        )}
      </Box>
    </KMKDialog>
  );
}
